import * as React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  Card,
  Button,
} from '@material-ui/core';
import { LanguageApi, LanguageLocal } from '../../../interfaces/Case';
import { AppContext, ApplicationContext } from '../../../context/Contexts';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { withSnackbar, ProviderContext } from 'notistack';

interface Props extends ProviderContext {
  languageApi: LanguageApi;
  languagesLocal: LanguageLocal[];
  fetchLanguages: () => void;
}

class LanguageLocalCard extends React.PureComponent<Props> {
  private translatorService!: ITranslatorService;
  
  static contextType = ApplicationContext;

  constructor(props: Props) {
    super(props);
  }

  checkIfLocalLanguageExists(language: LanguageApi) {
    return this.props.languagesLocal.some((lang) => lang.code === language.code);
  }

  showSnackbar = (result: 'success' | 'error') => {
    if (result === 'success') {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCESS_MSG', 'Succes'), {
        variant: 'success'
      });
    } else if (result === 'error') {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  }

  handleImport = async (code: string) => {
    try {
      const result = await this.translatorService.ImportLanguage({code});
      this.props.fetchLanguages();
      this.showSnackbar('success');
    } catch (error) {
      this.showSnackbar('error');
    }
  }

  handleUpdate = async (code: string) => {
    try {
      const result = await this.translatorService.UpdateLanguage({code});
      this.props.fetchLanguages();
      this.showSnackbar('success');
    } catch (error) {
      this.showSnackbar('error');
    }
  }

  handleDelete = async (code: string) => {
    try {
      const result = await this.translatorService.DeleteLanguage({code});
      this.props.fetchLanguages();
      this.showSnackbar('success');
    } catch (error) {
      this.showSnackbar('error');
    }
  }
  
  renderActionsButtons(language: LanguageApi) {
    if (this.checkIfLocalLanguageExists(language)) {
      return (
        <>
          <Button
            className="m-2"
            variant="contained"
            color="secondary"
            onClick={() => this.handleDelete(language.code)}
          >
            {this.translatorService.Tranlate('REMOVE', 'Sterge')}
          </Button>
          <Button
            className="m-2"
            variant="contained"
            color="primary"
            onClick={() => this.handleUpdate(language.code)}
          >
            {this.translatorService.Tranlate('UPDATE', 'Actualizeaza')}
          </Button>
        </>
      );
    } else {
      return (
        <Button
          className="m-2"
          variant="outlined"
          color="primary"
          onClick={() => this.handleImport(language.code)}
        >
          {this.translatorService.Tranlate('IMPORT', 'Importa')}
        </Button>
      );
    }
  }

  render() {
    this.translatorService = (this.context as AppContext).translatorService;

    return (
      <Card style={{ padding: '0 10px' }}>
        <List style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <ListItem style={{ display: 'flex', alignItems: 'center' }}>
            <ListItemText primary={this.props.languageApi.code} />
          </ListItem>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {this.renderActionsButtons(this.props.languageApi)}
          </div>
        </List>
      </Card>
    );
  }
}

export default withSnackbar(LanguageLocalCard);
